import { useState, useEffect } from 'react'

import { getLink, getLinkFromRef, isProduct, isIntegratedProduct } from '..'

export function usePagination({ page, component, parameters }) {
  const [items, setItems] = useState()

  useEffect(() => {
    const _models = component.getModels()

    if (!_models?.pagination) {
      return
    }

    const { pagination: _paginationRef } = _models

    // console.log('usePagination PAGINATIONREF >>>', _paginationRef)

    const pagination = _paginationRef && page.getContent(_paginationRef)

    // console.log('usePagination PAGINATION >>>', _pagination)

    if (pagination) {
      const itemRefs = pagination?.getItems()

      // console.log('usePagination ITEMREFS >>>', itemRefs)

      const items =
        itemRefs &&
        itemRefs.map((itemRef) => {
          const item = itemRef && page.getContent(itemRef)

          const data = item.getData()

          const translatedData = {}

          translatedData.id = data.id
          translatedData.title =
            isProduct() && !isIntegratedProduct()
              ? data?.title.replace('Columbia ', '')
              : data?.title // TODO: AWESOME HARDCODE
          translatedData.subtitle = data.subtitle || data.subhead
          translatedData.subtitle2 = data.subtitle2
          translatedData.publicationDate = data.publicationDate
          translatedData.time = data.time
          translatedData.summary =
            data.summary && typeof data.summary === 'object'
              ? data.summary.value
              : data.summary
          translatedData.html =
            data.html && typeof data.html === 'object'
              ? data.html.value
              : data.html || data.content
          translatedData.imageRef = data.image || data.heroImage
          translatedData.keys = data.keys
          translatedData.videoId = data.videoId
          translatedData.itemType = data.itemType
          translatedData.itemPrefix = data.itemPrefix
          translatedData.link = data.linkCompound
          translatedData.linkList = data.linkList

          const {
            id,
            title,
            subtitle,
            subtitle2,
            publicationDate,
            time,
            summary,
            html,
            imageRef,
            keys,
            videoId,
            itemType,
            itemPrefix,
            link,
            linkList,
          } = translatedData

          const image = imageRef && page?.getContent(imageRef)

          const imageUrl = image?.getOriginal().getUrl()
          const imageDescription = image?.getDescription()

          return {
            id,
            title,
            subtitle,
            subtitle2,
            publicationDate,
            time,
            summary,
            html,
            imageUrl,
            imageDescription,
            keys,
            videoId,
            itemType,
            itemPrefix,
            link: getLink(getLinkFromRef(link, page), id),
            linkList: linkList?.links
              .filter((l) => l.link && l.link.length > 0)
              .map((l) => getLink(getLinkFromRef(l, page), null)),
            document: item,
          }
        })

      setItems(items)
    }
  }, [page, component, parameters])

  return items
}
